const topicList = ["Basics", "Accomodation", "Promotions & Student Discount", "Orders & Merchandise", "Technical", "Others"];

const faqData = {
    Basics : [
        {
            question: "topic1 ques 1",
            answer : "topic1 ans 1"
        },
        {
            question: "topic1 ques 2",
            answer : "topic1 ans 2"
        },
        {
            question: "topic1 ques 3",
            answer : "topic1 ans 3"
        },
        {
            question: "topic1 ques 4",
            answer : "topic1 ans 4"
        },
        {
            question: "topic1 ques 5",
            answer : "topic1 ans 5"
        }
    ],
    Accomodation : [
        {
            question: "topic2 ques 1",
            answer : "topic2 ans 1"
        },
        {
            question: "topic2 ques 2",
            answer : "topic2 ans 2"
        },
        {
            question: "topic2 ques 3",
            answer : "topic2 ans 3"
        },
        {
            question: "topic2 ques 4",
            answer : "topic2 ans 4"
        },
        {
            question: "topic2 ques 5",
            answer : "topic2 ans 5"
        }
    ],
    "Promotions & Student Discount" : [
        {
            question: "topic3 ques 1",
            answer : "topic3 ans 1"
        },
        {
            question: "topic3 ques 2",
            answer : "topic3 ans 2"
        },
        {
            question: "topic3 ques 3",
            answer : "topic3 ans 3"
        },
        {
            question: "topic3 ques 4",
            answer : "topic3 ans 4"
        },
        {
            question: "topic3 ques 5",
            answer : "topic3 ans 5"
        }
    ],
    "Orders & Merchandise" : [
        {
            question: "topic4 ques 1",
            answer : "topic4 ans 1"
        },
        {
            question: "topic4 ques 2",
            answer : "topic4 ans 2"
        },
        {
            question: "topic4 ques 3",
            answer : "topic4 ans 3"
        },
        {
            question: "topic4 ques 4",
            answer : "topic4 ans 4"
        },
        {
            question: "topic4 ques 5",
            answer : "topic4 ans 5"
        }
    ],
    Technical : [
        {
            question: "topic5 ques 1",
            answer : "topic5 ans 1"
        },
        {
            question: "topic5 ques 2",
            answer : "topic5 ans 2"
        },
        {
            question: "topic5 ques 3",
            answer : "topic5 ans 3"
        },
        {
            question: "topic5 ques 4",
            answer : "topic5 ans 4"
        },
        {
            question: "topic5 ques 5",
            answer : "topic5 ans 5"
        }
    ],
    Others : [
        {
            question: "topic6 ques 1",
            answer : "topic6 ans 1"
        },
        {
            question: "topic6 ques 2",
            answer : "topic6 ans 2"
        },
        {
            question: "topic6 ques 3",
            answer : "topic6 ans 3"
        },
        {
            question: "topic6 ques 4",
            answer : "topic6 ans 4"
        },
        {
            question: "topic6 ques 5",
            answer : "topic6 ans 5"
        },
        {
            question: "topic6 ques 1",
            answer : "topic6 ans 1"
        },
        {
            question: "topic6 ques 2",
            answer : "topic6 ans 2"
        },
        {
            question: "topic6 ques 3",
            answer : "topic6 ans 3"
        },
        {
            question: "topic6 ques 4",
            answer : "topic6 ans 4"
        },
        {
            question: "topic6 ques 5",
            answer : "topic6 ans 5"
        },
        {
            question: "topic6 ques 1",
            answer : "topic6 ans 1"
        },
        {
            question: "topic6 ques 2",
            answer : "topic6 ans 2"
        },
        {
            question: "topic6 ques 3",
            answer : "topic6 ans 3"
        },
        {
            question: "topic6 ques 4",
            answer : "topic6 ans 4"
        },
        {
            question: "topic6 ques 5",
            answer : "topic6 ans 5"
        }
    ],
}

export {faqData, topicList};
